import * as React from "react";

import { HelmetDexteel } from "@dexteel/mesf-core";
import { ConfigurationProvider } from "../context/ConfigurationContext";

type Props = {};
const AlertLimit = (props: Props) => {
	return (
		<ConfigurationProvider>
			<HelmetDexteel title="Alerts - Configurations" />
			<div />
		</ConfigurationProvider>
	);
};
export default AlertLimit;
